import React from "react";
import { skinVars, Stack, Text3, Text6 } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";

export interface HeroDataInfoProps {
	icon?: React.ReactNode;
	title?: string;
	description?: string;
}

export const HeroDataInfo: React.FC<HeroDataInfoProps> = observer(({ icon, title, description }) => (
	<Stack space={24}>
		{icon}
		<Stack space={8}>
			<Text6 color={skinVars.colors.textPrimary}>{title}</Text6>
			<Text3 light color={skinVars.colors.textSecondary}>
				{description}
			</Text3>
		</Stack>
	</Stack>
));
